// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FileSidePanel-metadataContainer__VUGBO{padding:0 var(--size-4)}.FileSidePanel-metadataRow__DLVJQ{padding:var(--size-3) 0}.FileSidePanel-uploadedByValue__bvUOK{display:flex;gap:var(--size-2);align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"metadataContainer": "FileSidePanel-metadataContainer__VUGBO",
	"metadataRow": "FileSidePanel-metadataRow__DLVJQ",
	"uploadedByValue": "FileSidePanel-uploadedByValue__bvUOK"
};
export default ___CSS_LOADER_EXPORT___;
